const STATUS_COLORS = {
  "Poptávka": "bg-muted text-muted-foreground",
  "Nabídka": "bg-blue-500/15 text-blue-500",
  "Smlouva podepsána": "bg-purple-500/15 text-purple-400",
  "V realizaci": "bg-brand/15 text-brand",
  "Dokončeno": "bg-emerald-500/15 text-emerald-500",
  "Fakturováno": "bg-teal-500/15 text-teal-500",
  "Záruka": "bg-amber-500/15 text-amber-500",
};

export function StatusBadge({ status }) {
  const cls = STATUS_COLORS[status] || "bg-muted text-muted-foreground";
  return (
    <span data-testid="status-badge" className={`inline-flex items-center px-2.5 py-1 text-xs font-bold uppercase tracking-wider rounded-sm ${cls}`}>
      {status}
    </span>
  );
}
